import Input from './Input'

export default {
  name: 'input',
  configure: function(config) {
    config.addComponent('input', Input)
  }
}
